export enum UserAuthorizationResource {
  Policies = 'policies',
  Role = 'role'
}
